/* eslint-disable prettier/prettier */
/* eslint-disable arrow-parens */
import React, { useState, useCallback, useEffect, useRef, useContext, useMemo, Suspense } from "react";
import SelectedEmployeeGrid from "./SelectedEmployeeGrid";
import PopOver from "../../../../shared/popOvers/PopOver";
import { ADMIN_DASHBOARD_HEADER } from "../../../../../constants/caption/dashboardHeader";
import { AuthContext, GroupContext, UIContext } from "../../../../../contexts";
import DateFnsUtils from "@date-io/date-fns";
import "date-fns";

import downloadFile from "../../../../../utils/commonFunctions/downloadFile";
import shortenFileName from "../../../../../utils/commonFunctions/shortenFileName";

import {
	Grid,
	Button,
	Paper,
	Select,
	Tooltip,
	Chip,
	FormControl,
	InputLabel,
	Checkbox,
	TextField,
	IconButton,
	CheckboxProps,
	Menu,
	MenuItem
} from "@material-ui/core";
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import MuiAlert, { AlertProps } from "@material-ui/lab/Alert";
import { withStyles, makeStyles } from "@material-ui/core";
import { green } from "@material-ui/core/colors";

import { openEnrollmentBulkUploadTemplateFile } from "../../../../../assets";

import EventIcon from "@material-ui/icons/Event";
import AddIcon from "@material-ui/icons/Add";
import InfoIcon from "@material-ui/icons/Info";
import SendIcon from "@material-ui/icons/Send";

import "./openEnrollment.css";
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";
import { Member } from "../../../../../@types/member.types";
import { PaycheckConfig } from "../../../../../@types/group.types";
import { Plan, PlanPopOverContent, PlanStatus } from "../../../../../@types/plan.types";
import { api } from "../../../../../utils/api";
import { getActiveCorePlans } from "../../../../../utils/api/plan/plan";
import {
	AllOpenEnrollmentPayload,
	OpenEnrollmentInput,
	OpenEnrollmentSchema,
	OpenEnrollmentType,
	SpecificOpenEnrollmentPayload,
	VerifyBulkOpenEnrollmentPayload,
	YOEEffectiveDate,
	YOERenewalPlan,
	YOETermDate
} from "../../../../../@types/openEnrollment.types";
import { getOpenEnrollmentType } from "../../../../../utils/commonFunctions/plan";
import { EmployeWithOpenEnrollmentQuery } from "../../../../../utils/api/openEnrollment/openEnrollment";
import { MemberTypes } from "../../../../../@types/components/member.types";
import { useDebouncedCallback } from "use-debounce";
import Autocomplete from "react-autocomplete";
import { read, utils } from "xlsx";
import { LazyOpenedEnrollmentAlertDialog } from "../../..";
import useRouteParam from "../../../../../hooks/useRouteParam";
import { useNavigate } from "react-router-dom";
import { Validation } from "../../../../../@types/validation.types";
import { trackPromise } from "react-promise-tracker";
import { dateTimeZoneConverter } from "../../../../../utils/commonFunctions/date";
import { getPermissionsFromGroupOwner } from "../../../../../utils/getPermissionsFromGroupOwner";

const Alert = (props: AlertProps) => {
	return <MuiAlert elevation={6} variant="filled" {...props} />;
};

const GreenCheckbox = withStyles({
	root: {
		color: green[400],
		"&$checked": {
			color: green[600]
		}
	},
	checked: {}
})((props: CheckboxProps) => <Checkbox color="default" {...props} />);

const OpenEnrollment = () => {
	const [openEnrollment, setOpenEnrollment] = useState<OpenEnrollmentInput>();
	const [openOpenedEnrollmentAlertDialog, setOpenOpenedEnrollmentAlertDialog] = useState(false);
	const [openedEnrollmentEmployees, setOpenedEnrollmentEmployees] = useState<OpenEnrollmentSchema[]>([]);
	const [hasVerifiedBulkOpenEnrollmentFile, setHasVerifiedBulkOpenEnrollmentFile] = useState(false);
	const [plans, setPlans] = useState<Plan[]>([]);
	const [openEnrollmentPlan, setOpenEnrollmentPlan] = useState<Plan>();
	const [planPopOverContent, setPlanPopOverContent] = useState<PlanPopOverContent | null>(null);
	const [employees, setEmployees] = useState<Member[]>([]);
	const [bulkOpenEnrollmentFile, setBulkOpenEnrollmentFile] = useState<File | null>(null);
	const [selectedEmployees, setSelectedEmployees] = useState<Member[]>([]);
	const [validEmployees, setValidEmployees] = useState<Member[]>([]);
	const [invalidEmployeeMemberIDs, setInvalidEmployeeMemberIDs] = useState<string[]>([]);
	const [ineligibleEmployeeMemberIDs, setIneligibleEmployeeMemberIDs] = useState<string[]>([]);
	const [validMemberSSNs, setValidMemberSSNs] = useState<string[]>([]);
	const [anchorEl, setAnchorEl] = useState<(EventTarget & HTMLButtonElement) | null>(null);
	const [isButtonSelected, setIsButtonSelected] = useState(true);
	const [isYearlyOpenEnrollment, setIsYearlyOpenEnrollment] = useState(false);
	const [currentCorePlans, setCurrentCorePlans] = useState<Plan[]>([]);
	const [futureCorePlans, setFutureCorePlans] = useState<Plan[]>([]);
	const [selectedRenewalPlanId, setSelectedRenewalPlanId] = useState<string>("");
	// Per pay-frequency dates for the YOE renewal: term_dates -> current plan, effective_dates -> renewal plan
	const [termDates, setTermDates] = useState<YOETermDate[]>([]);
	const [effectiveDates, setEffectiveDates] = useState<YOEEffectiveDate[]>([]);
	const navigate = useNavigate();
	const queryGroupNumber = useRouteParam("gn");
	const { setDashboardHeader } = useContext(UIContext);
	const [searchMemberIdQuery, setSearchMemberIdQuery] = useState<string>("");
	const [searchFirstNameQuery, setSearchFirstNameQuery] = useState<string>("");
	const [searchLastNameQuery, setSearchLastNameQuery] = useState<string>("");
	const [searchSSNQuery, setSearchSSNQuery] = useState<string>("");
	const { currentGroup, setCurrentGroup } = useContext(GroupContext);
	const [validation, setValidation] = useState<Validation>({
		openEnrollment: {},
		status: "invalid"
	});
	const _validation = useRef<Validation>();
	// console.log("openEnrollment", openEnrollment);

	const { user, setUser } = useContext(AuthContext);

	const coreOpenEnrollmentPermission = user
		? getPermissionsFromGroupOwner(user, Number(queryGroupNumber))?.plan_control_menu.core_open_enrollment_sub.self
		: null;

	const handleOpenYearlyEnrollmentClick = () => {
		setIsYearlyOpenEnrollment((prevState) => {
			const next = !prevState;
			// When turning Yearly Open Enrollment off, reset all renewal selections.
			if (!next) {
				setSelectedRenewalPlanId("");
				setTermDates([]);
				setEffectiveDates([]);
			}
			return next;
		});
	};

	// Pay frequencies configured for the current group (e.g. ["WEEKLY", "MONTHLY"]).
	const payFrequencies = useMemo<string[]>(
		() => currentGroup?.paycheck_config?.map((pc: PaycheckConfig) => pc.pay_frequency) ?? [],
		[currentGroup?.paycheck_config]
	);

	const handleTermDateChange = useCallback((frequency: string, date: MaterialUiPickersDate) => {
		const term_date = date as unknown as string;
		setTermDates((prev) => {
			const existing = prev.find((item) => item.pay_frequency === frequency);
			if (existing) {
				return prev.map((item) => (item.pay_frequency === frequency ? { ...item, term_date } : item));
			}
			return [...prev, { pay_frequency: frequency, term_date }];
		});
	}, []);

	const handleEffectiveDateChange = useCallback((frequency: string, date: MaterialUiPickersDate) => {
		const effective_date = date as unknown as string;
		setEffectiveDates((prev) => {
			const existing = prev.find((item) => item.pay_frequency === frequency);
			if (existing) {
				return prev.map((item) => (item.pay_frequency === frequency ? { ...item, effective_date } : item));
			}
			return [...prev, { pay_frequency: frequency, effective_date }];
		});
	}, []);

	// Full YOE_renewal_plan object assembled from the selections
	const yoeRenewalPlan = useMemo<YOERenewalPlan>(() => {
		const renewalPlan = futureCorePlans.find((plan) => plan._id === selectedRenewalPlanId);
		return {
			plan_id: selectedRenewalPlanId,
			plan_name: renewalPlan?.plan_name ?? "",
			plan_code: renewalPlan?.plan_code ?? "",
			term_dates: termDates,
			effective_dates: effectiveDates
		};
	}, [selectedRenewalPlanId, futureCorePlans, termDates, effectiveDates]);

	const getPlanById = useCallback(
		(_id: string): Plan | null => {
			let plan: Plan | null = null;

			for (let planIdx = 0; planIdx < plans.length; planIdx++) {
				if (_id === plans[planIdx]._id) {
					plan = plans[planIdx];
					break;
				}
			}
			return plan;
		},
		[plans]
	);

	const handleValidation = useCallback(async () => {
		_validation.current = {
			...validation,
			openEnrollment: {},
			status: "invalid"
		};
		let flag = true;

		if (openEnrollment === undefined) {
			_validation.current["status"] = "invalid";
			flag = false;
		}

		if (openEnrollment?.plan === undefined || openEnrollment?.plan === "") {
			_validation.current.openEnrollment["plan"] = "Plan is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		if (openEnrollment?.type === undefined) {
			_validation.current.openEnrollment["type"] = "Assignment Type is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}

		if (openEnrollment?.start_date === undefined || String(openEnrollment?.start_date).length === 0) {
			_validation.current.openEnrollment["start_date"] = "Start date is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		if (openEnrollment?.end_date === undefined || String(openEnrollment?.end_date).length === 0) {
			_validation.current.openEnrollment["end_date"] = "End date is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		if (String(openEnrollment?.end_date).length !== 0) {
			const endDate = new Date(openEnrollment?.end_date as any).getTime();

			const startDate = new Date(openEnrollment?.start_date as any).getTime();

			if (endDate < startDate) {
				// console.log("In the if");
				_validation.current.openEnrollment["end_date"] = "End Date cannot be less than start date";
				_validation.current["status"] = "invalid";
				flag = false;
			}
		}
		if (flag === true) _validation.current["status"] = "valid";
		else {
			_validation.current["status"] = "invalid";
			alert("Please, fill all required fields!");
		}
		setValidation(Object.assign({}, _validation.current));
		return _validation.current["status"];
	}, [openEnrollment, validation]);

	const handleOpenEnrollmentChange = useCallback(
		(event: React.ChangeEvent<HTMLInputElement | { name?: string | undefined; value: unknown }>) => {
			const { name, checked, value } = event.target as HTMLInputElement;
			let field;
			// console.log("name", name, value);

			if (name === "plan") {
				setOpenEnrollment(Object.assign({}, openEnrollment, { plan: value }));
				const plan = getPlanById(value);
				if (plan === null) {
					alert("Invalid plan id");
					return;
				}
				setPlanPopOverContent(
					Object.assign(
						{},
						{
							plan_name: plan.plan_name,
							plan_code: plan.plan_code,
							start_date: dateTimeZoneConverter(plan?.start_date as string) as string,
							end_date: plan?.end_date
								? (dateTimeZoneConverter(plan.end_date as string) as string)
								: plan?.end_date === null
								? "Not Mentioned"
								: (plan?.end_date as string),
							buy_up_eligibility: plan.buy_up_eligibility ? "Yes" : "No",
							employee_class: plan.employee_class
						}
					)
				);
				setSearchFirstNameQuery("");
				setSearchMemberIdQuery("");
				setEmployees([]);
			} else {
				if (value === "ALL" || value === "BULK" || value === "SPECIFIC") {
					field = "type";
					setOpenEnrollment(Object.assign({}, openEnrollment, { [field]: value }));
				} else {
					setOpenEnrollment(Object.assign({}, openEnrollment, { [name]: value }));
				}
			}
		},
		[getPlanById, openEnrollment]
	);

	const handleDeleteBulkOpenEnrollmentFile = useCallback(() => {
		setBulkOpenEnrollmentFile(null);
		setHasVerifiedBulkOpenEnrollmentFile(false);
	}, []);

	const handleBulkOpenEnrollmentFileUpload = useCallback(
		(event: React.ChangeEvent<HTMLInputElement>) => {
			const { files } = event.target;
			if (!(files && files[0])) {
				return;
			}
			const _enrolledFile = {
				...openEnrollment,
				enrolled_file: files[0],
				filename: files[0].name
			};
			setBulkOpenEnrollmentFile(files[0]);
			event.target.value = "";
		},
		[openEnrollment]
	);

	// const handleDateChange = useCallback(
	// 	(_date: MaterialUiPickersDate, name: string) => {
	// 		// console.log("Name", name);
	// 		const date = new Date(_date as any);
	// 		const parsedDate = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
	// 		setOpenEnrollment(Object.assign({}, openEnrollment, { [name]: parsedDate }));
	// 	},
	// 	[openEnrollment]
	// );

	const handleDateChange = useCallback(
		(_date: MaterialUiPickersDate, name: string) => {
			const parsedDate = _date as unknown as string;
			setOpenEnrollment(Object.assign({}, openEnrollment, { [name]: parsedDate }));
		},
		[openEnrollment]
	);

	const handleSearchEmployeeChange = useCallback(
		async (
			// eslint-disable-next-line @typescript-eslint/ban-types
			event: React.ChangeEvent<HTMLInputElement>,
			field: string
		) => {
			if (!openEnrollment?.start_date) {
				alert("Please enter start date");
				return;
			}
			if (!openEnrollment?.end_date) {
				alert("Please enter end date");
				return;
			}
			const { value } = event.target;
			if (field === "member_id") {
				setSearchMemberIdQuery(value);
			} else if (field === "first_name") {
				setSearchFirstNameQuery(value);
			} else if (field === "last_name") {
				setSearchLastNameQuery(value);
			} else if (field === "SSN") {
				setSearchSSNQuery(value);
			}
			if (value === "" || value === null) {
				setEmployees([]);
				return;
			}
			if (openEnrollment === undefined || queryGroupNumber === undefined || queryGroupNumber === null) {
				return;
			}
			const employeeWithOpenEnrollmentQuery: EmployeWithOpenEnrollmentQuery = {
				field,
				query: value,
				page: "1",
				limit: "10000",
				plan_id: openEnrollment.plan,
				start_date: openEnrollment.start_date,
				end_date: openEnrollment.end_date
			};
			const _employees = await api.openEnrollment.getEmployeeWithOpenEnrollmentStartWith(
				employeeWithOpenEnrollmentQuery,
				queryGroupNumber as number
			);

			if (_employees) {
				setEmployees(Object.assign([], [..._employees]));
			} else {
				setEmployees([]);
			}
		},
		[openEnrollment, queryGroupNumber]
	);

	const handleOpenPlanDetailsPopOverClick = useCallback((event: React.MouseEvent<HTMLButtonElement>) => {
		// console.log("Mouse Enter");
		setAnchorEl(event.currentTarget);
	}, []);

	const handleClosePopOver = useCallback(() => {
		// console.log("Mouse Close");
		setAnchorEl(null);
	}, []);

	const handleSelectSearchedEmployee = useCallback(
		(value: string, _selectedEmployee: Member & { open_enrollment: any }) => {
			if (_selectedEmployee.open_enrollment) {
				alert("Enrollment already opened for employee");
				return;
			}
			let isEmployeeSelected = false;
			for (let employeeIdx = 0; employeeIdx < selectedEmployees.length; employeeIdx++) {
				const { SSN } = selectedEmployees[employeeIdx];
				if (SSN === _selectedEmployee.SSN) {
					isEmployeeSelected = true;
					break;
				}
			}
			if (isEmployeeSelected === false) {
				setSelectedEmployees((prevSelectedEmployees: Member[]) => {
					return Object.assign([], [...prevSelectedEmployees, _selectedEmployee]);
				});
			}
		},
		[selectedEmployees]
	);

	function stripTime(date: Date): Date {
		return new Date(date.getFullYear(), date.getMonth(), date.getDate());
	}

	const handleOpenEnrollmentSubmitClick = useCallback(async () => {
		const validation = await handleValidation();
		if (validation === "valid" && openEnrollment && queryGroupNumber) {
			// console.log(openEnrollment);
			const { plan, type, start_date, end_date } = openEnrollment;

			const startDate = new Date(start_date);
			const endDate = new Date(end_date);

			const formatRenewalDate = (value: string | Date | null): string | null => {
				if (!value) return null;
				const d = new Date(value as any);
				return d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate();
			};
			const formattedYOERenewalPlan: YOERenewalPlan = {
				...yoeRenewalPlan,
				term_dates: yoeRenewalPlan.term_dates.map((item) => ({
					pay_frequency: item.pay_frequency,
					term_date: formatRenewalDate(item.term_date)
				})),
				effective_dates: yoeRenewalPlan.effective_dates.map((item) => ({
					pay_frequency: item.pay_frequency,
					effective_date: formatRenewalDate(item.effective_date)
				}))
			};

			if (plan && type && start_date && end_date) {
				const openEnrollmentType = getOpenEnrollmentType(plans, plan);
				if (openEnrollmentType) {
					switch (type) {
						case "ALL": {
							if (stripTime(endDate) <= stripTime(startDate)) {
								alert("End date must be greater than start date.");
								break;
							}
							const allOpenEnrollmentPayload: AllOpenEnrollmentPayload = {
								plan_id: plan,
								start_date:
									startDate.getFullYear() +
									"-" +
									(startDate.getMonth() + 1) +
									"-" +
									startDate.getDate(),
								end_date:
									endDate.getFullYear() + "-" + (endDate.getMonth() + 1) + "-" + endDate.getDate(),
								open_enrollment_VEB: false,
								type: openEnrollmentType,
								group_number: queryGroupNumber as number
							};
							const openEnrollment = await trackPromise(
								api.openEnrollment.allOpenEnrollment(allOpenEnrollmentPayload)
							);
							// console.log("openEnrollment", openEnrollment);
							if (openEnrollment.status === true) {
								alert("Open Enrollment Successfully done!");
								const pathname = `/employer/all-enrollments?gn=${queryGroupNumber}`;
								navigate(pathname);
							} else {
								// console.log("openEnrollment.result", openEnrollment.result);
								setOpenedEnrollmentEmployees(
									Object.assign([], openEnrollment.result.openEnrollmentEmployees)
								);
								setOpenEnrollmentPlan(Object.assign({}, openEnrollment.result.plan));
								setOpenOpenedEnrollmentAlertDialog(true);
							}
							break;
						}
						case "SPECIFIC": {
							if (stripTime(endDate) <= stripTime(startDate)) {
								alert("End date must be greater than start date.");
								break;
							}
							const allOpenEnrollmentPayload: AllOpenEnrollmentPayload & {
								open_enrollment_for: OpenEnrollmentType;
							} = {
								plan_id: plan,
								start_date:
									startDate.getFullYear() +
									"-" +
									(startDate.getMonth() + 1) +
									"-" +
									startDate.getDate(),
								end_date:
									endDate.getFullYear() + "-" + (endDate.getMonth() + 1) + "-" + endDate.getDate(),
								open_enrollment_VEB: false,
								type: isYearlyOpenEnrollment ? "YEARLY" : openEnrollmentType,
								open_enrollment_for: "SPECIFIC",
								group_number: queryGroupNumber as number,
								is_yearlyopenenrollment: isYearlyOpenEnrollment,
								...(isYearlyOpenEnrollment ? { YOE_renewal_plan: formattedYOERenewalPlan } : {})
							};
							const specificOpenEnrollmentPayload: SpecificOpenEnrollmentPayload = {
								open_enrollment: allOpenEnrollmentPayload,
								employee_SSNs: selectedEmployees.map(({ SSN }: Member) => SSN)
							};
							const openEnrollment = await trackPromise(
								api.openEnrollment.specificOpenEnrollment(specificOpenEnrollmentPayload)
							);
							// console.log("openEnrollment", openEnrollment);
							if (openEnrollment.status === true) {
								// console.log("openEnrollment", openEnrollment);
								alert("Open Enrollment Successfully done!");
								const pathname = `/employer/all-enrollments?gn=${queryGroupNumber}`;
								navigate(pathname);
							} else {
								// console.log("openEnrollment.result", openEnrollment.result);
								alert("Open enrollment already done for member!");
								setOpenedEnrollmentEmployees(
									Object.assign([], openEnrollment.result.openEnrollmentEmployees)
								);
								setOpenOpenedEnrollmentAlertDialog(true);
							}
							break;
						}
						case "BULK": {
							if (stripTime(endDate) <= stripTime(startDate)) {
								alert("End date must be greater than start date.");
								break;
							}
							const allOpenEnrollmentPayload: AllOpenEnrollmentPayload & {
								open_enrollment_for: OpenEnrollmentType;
							} = {
								plan_id: plan,
								start_date:
									startDate.getFullYear() +
									"-" +
									(startDate.getMonth() + 1) +
									"-" +
									startDate.getDate(),
								end_date:
									endDate.getFullYear() + "-" + (endDate.getMonth() + 1) + "-" + endDate.getDate(),
								open_enrollment_VEB: false,
								open_enrollment_for: "BULK",
								type: isYearlyOpenEnrollment ? "YEARLY" : openEnrollmentType,
								group_number: queryGroupNumber as number,
								is_yearlyopenenrollment: isYearlyOpenEnrollment,
								...(isYearlyOpenEnrollment ? { YOE_renewal_plan: formattedYOERenewalPlan } : {})
							};
							const specificOpenEnrollmentPayload: SpecificOpenEnrollmentPayload = {
								open_enrollment: allOpenEnrollmentPayload,
								employee_SSNs: validMemberSSNs
							};
							const openEnrollment = await trackPromise(
								api.openEnrollment.specificOpenEnrollment(specificOpenEnrollmentPayload)
							);
							if (openEnrollment.status === true) {
								alert("Open Enrollment Successfully done!");
								const pathname = `/employer/all-enrollments?gn=${queryGroupNumber}`;
								navigate(pathname);
							} else {
								// console.log("openEnrollment.result", openEnrollment.result);
								setOpenedEnrollmentEmployees(
									Object.assign([], openEnrollment.result.openEnrollmentEmployees)
								);
								setOpenOpenedEnrollmentAlertDialog(true);
							}
							break;
						}
					}
				}
			}
		}
	}, [
		navigate,
		openEnrollment,
		plans,
		queryGroupNumber,
		selectedEmployees,
		validMemberSSNs,
		handleValidation,
		isYearlyOpenEnrollment,
		yoeRenewalPlan
	]);

	// console.log("opened", openedEnrollmentEmployees);

	const handleVerifyBulkOpenEnrollmentFileClick = useCallback(async () => {
		if (bulkOpenEnrollmentFile === null) {
			alert("Please Upload Bulk Open Enrollment File");
			return;
		}
		if (!openEnrollment?.plan) {
			alert("Please select a Plan before verifying");
			return;
		}
		const fileReader = new FileReader();
		fileReader.onload = async function (e) {
			if (e?.target === null) {
				return;
			}
			const data = e.target.result;
			const workbook = read(e.target.result);
			// console.log("workbook", workbook);
			const sheet2JsonData = utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]], {
				header: ["employee_id"]
			});
			const employeeIDs: string[] = sheet2JsonData.map((value: any, index: number) => {
				// console.log("value", value.employee_id.toString());
				return value.employee_id.toString();
			});
			employeeIDs.shift();
			const verifyBulkOpenEnrollmentPayload: VerifyBulkOpenEnrollmentPayload = {
				employee_IDs: employeeIDs,
				plan_id: openEnrollment.plan as string
			};
			const { validEmployees, ineligibleEmployees } = await trackPromise(
				api.openEnrollment.verifyBulkOpenEnrollment(verifyBulkOpenEnrollmentPayload)
			);
			const _validEmployeeMemberIDs: string[] = [];
			const _validMemberSSNs: string[] = [];
			for (let employeeIdx = 0; employeeIdx < validEmployees.length; employeeIdx++) {
				const { member_id, SSN } = validEmployees[employeeIdx];
				_validEmployeeMemberIDs.push(member_id as string);
				_validMemberSSNs.push(SSN);
			}

			const _ineligibleEmployeeMemberIDs = ineligibleEmployees.map(
				(employee) => employee.member_id as string
			);

			const _invalidEmployeeMemberIDs = employeeIDs.filter(
				(employeeID) =>
					_validEmployeeMemberIDs.indexOf(employeeID) < 0 &&
					_ineligibleEmployeeMemberIDs.indexOf(employeeID) < 0
			);
			setValidMemberSSNs(Object.assign([], _validMemberSSNs));
			setInvalidEmployeeMemberIDs(Object.assign([], _invalidEmployeeMemberIDs));
			setIneligibleEmployeeMemberIDs(Object.assign([], _ineligibleEmployeeMemberIDs));
			setValidEmployees(Object.assign([], validEmployees));
			setHasVerifiedBulkOpenEnrollmentFile(true);
		};
		fileReader.readAsArrayBuffer(bulkOpenEnrollmentFile);
	}, [bulkOpenEnrollmentFile, openEnrollment?.plan]);

	const getPlans = useCallback(async () => {
		if (queryGroupNumber) {
			const planStatus: PlanStatus = "ACTIVE";
			const query = {
				status: planStatus,
				group_number: queryGroupNumber,
				is_always_open: false
			};
			const _plans = await trackPromise(api.plan.getPlans(query));
			setPlans(Object.assign([], _plans));
		}
	}, [queryGroupNumber]);

	useEffect(() => {
		if (queryGroupNumber) {
			const fetchGroup = async () => {
				try {
					const group = await api.group.getGroupByGroupNumber(queryGroupNumber as number);
					setCurrentGroup(group);
				} catch (error) {
					console.error("Error fetching group:", error);
				}
			};

			fetchGroup();
		}
	}, [queryGroupNumber, setCurrentGroup]);

	useEffect(() => {
		getPlans();
		setDashboardHeader(ADMIN_DASHBOARD_HEADER.open_enrollment);
	}, [setDashboardHeader, getPlans]);

	// Fetch the current (selectable-now) and future (renewal-eligible) CORE plans for the group.
	// currentCorePlans feeds the main "Select Plan" dropdown below so a future plan year can't be
	// picked for a regular/HIRE/SPECIAL OE; futurePlans feeds the Renewal Plan dropdown inside the
	// Yearly Open Enrollment panel. `plans` (from the generic getPlans() below) stays untouched since
	// it's also used for getOpenEnrollmentType/getPlanById lookups that need the full active list.
	useEffect(() => {
		if (!queryGroupNumber || futureCorePlans.length > 0) {
			return;
		}
		const fetchActiveCorePlans = async () => {
			try {
				const { currentPlans, futurePlans } = await trackPromise(getActiveCorePlans(queryGroupNumber as number));
				setCurrentCorePlans(Object.assign([], currentPlans));
				setFutureCorePlans(Object.assign([], futurePlans));
			} catch (error) {
				console.error("Error fetching active CORE plans:", error);
			}
		};
		fetchActiveCorePlans();
	}, [queryGroupNumber, futureCorePlans.length]);

	const onBlurFunctionality = () => {
		setEmployees([]);
	};

	return (
		<>
			{
				<Suspense fallback={<div />}>
					{openEnrollmentPlan ? (
						<LazyOpenedEnrollmentAlertDialog
							plan={openEnrollmentPlan}
							openOpenedEnrollmentAlertDialog={openOpenedEnrollmentAlertDialog}
							setOpenOpenedEnrollmentAlertDialog={setOpenOpenedEnrollmentAlertDialog}
							openedEnrollmentEmployees={openedEnrollmentEmployees}
						/>
					) : null}
				</Suspense>
			}
			<div className="open-enrollment-container" id="open-enrollment-container">
				<Grid container spacing={1} className="pf-grid-container ">
					<div className="pf-title">Open Enrollment for Employees</div>
					<Paper className="pf-paper-container " elevation={3} variant="outlined">
						<Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
							<Grid container spacing={1} className="pf-label">
								<Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
									<div className="pf-label-text required">Select Plan </div>
								</Grid>
								<Grid item xs={9} sm={9} md={9} lg={9} xl={9} className="plan-hyper-link-container">
									<FormControl variant="outlined">
										<Select
											className="frequency-container"
											name="plan"
											value={openEnrollment?.plan}
											onChange={handleOpenEnrollmentChange}
											disabled={!isButtonSelected}
											style={{
												cursor: !isButtonSelected ? "not-allowed" : "pointer",
												pointerEvents: "unset",
												width: 340,
												textAlign: "left",
												overflowY: "visible"
											}}
											MenuProps={{
												style: { zIndex: 35960 }
											}}
											inputProps={{ "aria-label": "Without label" }}
										>
											{currentCorePlans
												// getActiveCorePlans doesn't exclude is_always_open plans the way the
												// plans/getPlanById list below does — filter them out here so a
												// selection here always resolves via getPlanById instead of tripping
												// its "Invalid plan id" alert.
												.filter((plan) => !plan.is_always_open)
												.map((plan: Plan, index: number) => {
													const { plan_name, plan_code, _id } = plan;
													return (
														<MenuItem value={_id} key={index}>
															<span className="plan-name-menu-item">{`${plan_name} -`}</span>
															<span className="plan-code-menu-item">{`${plan_code}`}</span>
														</MenuItem>
													);
												})}
										</Select>
										{validation?.openEnrollment?.plan ? (
											<div className="details">
												<span className="select-validation-text2">
													{validation.openEnrollment.plan}
												</span>
											</div>
										) : null}
									</FormControl>
									{planPopOverContent !== null ? (
										<>
											<IconButton
												onClick={handleOpenPlanDetailsPopOverClick}
												onMouseEnter={handleOpenPlanDetailsPopOverClick}
												// onMouseOut={handleClosePopOver}
											>
												<InfoIcon
													style={{
														marginTop: "0.2rem",
														fontSize: "1.8rem",
														color: "#4169e1"
													}}
												/>
											</IconButton>
											<PopOver
												popOverTitle={"Plan Details"}
												anchorEl={anchorEl}
												popOverContent={planPopOverContent}
												setAnchorEl={setAnchorEl}
												// handleClosePopOver={handleClosePopOver}
											/>
										</>
									) : null}
								</Grid>
							</Grid>
							<Grid container spacing={1} className="pf-label">
								<Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
									<div className="pf-label-text required">Yearly Open Enrollment</div>
								</Grid>
								<span className="enroll-check-label">
									<GreenCheckbox
										name="is_yearlyopenenrollment"
										value={isYearlyOpenEnrollment}
										onChange={handleOpenYearlyEnrollmentClick}
										checked={isYearlyOpenEnrollment}
									/>
									<label htmlFor="is_yearlyopenenrollment" className="pf-label-text ">
										Yes
									</label>
								</span>
							</Grid>
							{isYearlyOpenEnrollment ? (
								<div className="yearly-open-enrollment-container">
									<Grid container spacing={1} className="pf-grid-container ">
										<div className="pf-title">Yearly Open Enrollment Configuration</div>
										<Paper className="pf-paper-container " elevation={3} variant="outlined">
											<Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
												<Grid container spacing={1} className="pf-label">
													<Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
														<div className="pf-label-text">Renewal Plan</div>
													</Grid>
													<Grid item xs={9} sm={9} md={9} lg={9} xl={9}>
														<FormControl variant="outlined" style={{ minWidth: 340 }}>
															<InputLabel id="yoe-renewal-plan-label">Select renewal plan</InputLabel>
															<Select
																labelId="yoe-renewal-plan-label"
																label="Select renewal plan"
																value={selectedRenewalPlanId}
																onChange={(event) =>
																	setSelectedRenewalPlanId(event.target.value as string)
																}
															>
																{futureCorePlans.length === 0 ? (
																	<MenuItem value="" disabled>
																		No upcoming plans found
																	</MenuItem>
																) : (
																	futureCorePlans.map((plan) => (
																		<MenuItem key={plan._id} value={plan._id}>
																			{`${plan.plan_name} (${plan.plan_code})`}
																		</MenuItem>
																	))
																)}
															</Select>
														</FormControl>
													</Grid>
												</Grid>
												{payFrequencies.length > 0 ? (
													<Grid container spacing={2} className="pf-label">
														{payFrequencies.map((frequency) => {
															const label = frequency.charAt(0) + frequency.slice(1).toLowerCase();
															const termDateValue =
																termDates.find((item) => item.pay_frequency === frequency)
																	?.term_date ?? null;
															const effectiveDateValue =
																effectiveDates.find((item) => item.pay_frequency === frequency)
																	?.effective_date ?? null;
															return (
																<Grid
																	item
																	xs={12}
																	md={payFrequencies.length === 1 ? 12 : 6}
																	key={frequency}
																>
																	<Paper
																		variant="outlined"
																		style={{ padding: 20, height: "100%", borderRadius: 8 }}
																	>
																		<p
																			style={{
																				fontWeight: 800,
																				fontSize: 16,
																				textDecoration: "underline",
																				marginTop: 0,
																				marginBottom: 16
																			}}
																		>
																			For {label} Paychecks
																		</p>
																		<div className="pf-label-text" style={{ marginBottom: 6 }}>
																			Current Plan Term Date
																		</div>
																		<MuiPickersUtilsProvider utils={DateFnsUtils}>
																			<KeyboardDatePicker
																				className="from-date-input"
																				inputVariant="outlined"
																				label="Term Date"
																				placeholder="Enter Term Date"
																				format="MM/dd/yyyy"
																				error={false}
																				value={termDateValue}
																				onChange={(date) => handleTermDateChange(frequency, date)}
																				InputProps={{ readOnly: true }}
																				InputLabelProps={{ shrink: true }}
																				keyboardIcon={<EventIcon style={{ color: "#7cb342" }} />}
																				KeyboardButtonProps={{ "aria-label": "change date" }}
																				style={{
																					pointerEvents: "unset",
																					width: "100%",
																					borderRadius: 50
																				}}
																			/>
																		</MuiPickersUtilsProvider>
																		<div className="pf-label-text" style={{ margin: "20px 0 6px" }}>
																			Renewal Plan Effective Date
																		</div>
																		<MuiPickersUtilsProvider utils={DateFnsUtils}>
																			<KeyboardDatePicker
																				className="from-date-input"
																				inputVariant="outlined"
																				label="Effective Date"
																				placeholder="Enter Effective Date"
																				format="MM/dd/yyyy"
																				error={false}
																				value={effectiveDateValue}
																				onChange={(date) =>
																					handleEffectiveDateChange(frequency, date)
																				}
																				InputProps={{ readOnly: true }}
																				InputLabelProps={{ shrink: true }}
																				keyboardIcon={<EventIcon style={{ color: "#7cb342" }} />}
																				KeyboardButtonProps={{ "aria-label": "change date" }}
																				style={{
																					pointerEvents: "unset",
																					width: "100%",
																					borderRadius: 50
																				}}
																			/>
																		</MuiPickersUtilsProvider>
																	</Paper>
																</Grid>
															);
														})}
													</Grid>
												) : (
													<Grid container spacing={1} className="pf-label">
														<Grid item xs={12}>
															<div className="pf-label-text">
																No paycheck configuration found for this group.
															</div>
														</Grid>
													</Grid>
												)}
											</Grid>
										</Paper>
									</Grid>
								</div>
							) : null}
							<Grid container spacing={1} className="pf-label">
								<Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
									<div className="pf-label-text required">Assigned To</div>
								</Grid>
								<Grid item xs={9} sm={9} md={9} lg={9} xl={9} className="assigned-value-container">
									<span className="enroll-check-label">
										<GreenCheckbox
											name="type"
											value="ALL"
											onChange={handleOpenEnrollmentChange}
											checked={openEnrollment?.type === "ALL" ? true : false}
										/>
										<label htmlFor="all" className="pf-label-text ">
											All
										</label>
									</span>
									<span className="enroll-check-label">
										<GreenCheckbox
											name="type"
											value="BULK"
											onChange={handleOpenEnrollmentChange}
											checked={openEnrollment?.type === "BULK" ? true : false}
										/>
										<label htmlFor="bulk" className="pf-label-text assigned-label">
											Bulk
										</label>
									</span>
									<span className="enroll-check-label">
										<GreenCheckbox
											name="type"
											value="SPECIFIC"
											onChange={handleOpenEnrollmentChange}
											checked={openEnrollment?.type === "SPECIFIC" ? true : false}
										/>
										<label
											htmlFor="specific"
											className="pf-label-text "
											style={{ textAlign: "center" }}
										>
											Specific
										</label>
									</span>
								</Grid>
								<Grid item xs={12} sm={12} md={3} lg={3} xl={3}></Grid>
								<Grid item xs={9} sm={9} md={9} lg={9} xl={9}>
									{validation?.openEnrollment?.type ? (
										<div className="details">
											<span className="select-validation-text2">
												{validation.openEnrollment.type}
											</span>
										</div>
									) : null}
								</Grid>
							</Grid>
							<Grid container spacing={1} className="pf-label">
								<Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
									<div className="pf-label-text required">Start Date</div>
								</Grid>
								<Grid item xs={9} sm={9} md={9} lg={9} xl={9}>
									<MuiPickersUtilsProvider utils={DateFnsUtils}>
										<KeyboardDatePicker
											className="from-date-input"
											id="from-date-input"
											inputVariant="outlined"
											label="Start date"
											placeholder="Enter Start Date"
											name="start_date"
											format="MM/dd/yyyy"
											disablePast
											error={false}
											value={openEnrollment?.start_date ? openEnrollment?.start_date : ""}
											onChange={(date) => handleDateChange(date, "start_date")}
											InputProps={{
												readOnly: true
											}}
											InputLabelProps={{
												shrink: true
											}}
											keyboardIcon={<EventIcon style={{ color: "#7cb342" }} />}
											KeyboardButtonProps={{
												"aria-label": "change date"
											}}
											style={{
												pointerEvents: "unset",
												width: "340px",
												borderRadius: 50
											}}
											helperText={validation.openEnrollment.start_date}
										/>
									</MuiPickersUtilsProvider>
								</Grid>
							</Grid>
							<Grid container spacing={1} className="pf-label">
								<Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
									<div className="pf-label-text required">End Date</div>
								</Grid>
								<Grid item xs={9} sm={9} md={9} lg={9} xl={9}>
									<MuiPickersUtilsProvider utils={DateFnsUtils}>
										<KeyboardDatePicker
											className="from-date-input"
											id="from-date-input"
											inputVariant="outlined"
											label="End Date"
											placeholder="Enter End Date"
											name="end_date"
											format="MM/dd/yyyy"
											disablePast
											error={false}
											value={openEnrollment?.end_date ? openEnrollment.end_date : ""}
											onChange={(date) => handleDateChange(date, "end_date")}
											InputProps={{
												readOnly: true
											}}
											InputLabelProps={{
												shrink: true
											}}
											keyboardIcon={<EventIcon style={{ color: "#7cb342" }} />}
											KeyboardButtonProps={{
												"aria-label": "change date"
											}}
											style={{
												pointerEvents: "unset",
												width: "340px",
												borderRadius: 50
											}}
											helperText={validation?.openEnrollment?.end_date}
										/>
									</MuiPickersUtilsProvider>
								</Grid>
							</Grid>
						</Grid>
					</Paper>
				</Grid>
				{openEnrollment?.type === "BULK" ? (
					<div className="bulk-upload-container">
						<Grid container spacing={1} className="pf-grid-container ">
							<div className="pf-title">Bulk Upload</div>
							<Paper className="pf-paper-container " elevation={3} variant="outlined">
								<Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
									<Grid container spacing={1} className="pf-label">
										<Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
											<div className="pf-label-text">Upload File</div>
										</Grid>
										<Grid item xs={9} sm={9} md={9} lg={9} xl={9}>
											{bulkOpenEnrollmentFile === null ? (
												<>
													<input
														className={"document-upload"}
														id={"document-upload"}
														name="enrolled_file"
														type="file"
														onChange={handleBulkOpenEnrollmentFileUpload}
														style={{ display: "none" }}
														accept=".xlsx, .csv"
													/>
													<label htmlFor={"document-upload"}>
														<Button
															className="button enrollment-upload-btn"
															component="span"
															variant="contained"
															style={{
																backgroundColor: "#3A4652",
																color: "#ffff",
																width: 210
															}}
														>
															<span
																className="button-label-with-icon"
																style={{ color: "#ffff" }}
															>
																Add Excel/CSV
															</span>
															<span>
																<AddIcon
																	className="button-icon"
																	style={{ color: "#ffff" }}
																/>
															</span>
														</Button>
													</label>
												</>
											) : (
												<Tooltip title={"Click to download"} arrow>
													<Chip
														label={
															bulkOpenEnrollmentFile
																? shortenFileName(bulkOpenEnrollmentFile.name)
																: "No files added"
														}
														onDelete={() => handleDeleteBulkOpenEnrollmentFile()}
														onClick={() => downloadFile(bulkOpenEnrollmentFile)}
													/>
												</Tooltip>
											)}
											<span className="demo-file-label">
												<a
													href={openEnrollmentBulkUploadTemplateFile}
													download="Open enrollment Bulk Upload Template File"
												>
													(Download Template File)
												</a>
											</span>
										</Grid>
										{bulkOpenEnrollmentFile !== null &&
										hasVerifiedBulkOpenEnrollmentFile === true ? (
											<>
												{invalidEmployeeMemberIDs.length > 0 ? (
													<Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
														<Alert severity="warning" className="bulk-upld-alert-container">
															<div className="error-display-container">
																This is an error message. The following employees are
																invalid.
															</div>
															<div className="emp-id-display-container">
																{invalidEmployeeMemberIDs.map((memberID, index) => {
																	return (
																		<div key={index}>Employee Id - {memberID}</div>
																	);
																})}
															</div>
														</Alert>
													</Grid>
												) : null}
												{ineligibleEmployeeMemberIDs.length > 0 ? (
													<Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
														<Alert severity="warning" className="bulk-upld-alert-container">
															<div className="error-display-container">
																The following employees are not eligible for the
																selected plan&apos;s employee class and will not be
																enrolled.
															</div>
															<div className="emp-id-display-container">
																{ineligibleEmployeeMemberIDs.map((memberID, index) => {
																	return (
																		<div key={index}>Employee Id - {memberID}</div>
																	);
																})}
															</div>
														</Alert>
													</Grid>
												) : null}
												<Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
													<SelectedEmployeeGrid
														selectedEmployees={validEmployees}
														type={"BULK"}
														setSelectedEmployees={setValidEmployees}
													/>
												</Grid>
											</>
										) : null}
									</Grid>
								</Grid>
							</Paper>
						</Grid>
					</div>
				) : null}
				{openEnrollment?.type === "SPECIFIC" ? (
					<div className="specific-add-employees-container">
						<Grid container spacing={1} className="pf-grid-container">
							<div className="pf-title">Add Employee</div>
							<Paper className="pf-paper-container " elevation={3} variant="outlined">
								<Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
									<Grid container spacing={1} className="pf-label">
										<Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
											<div className="pf-label-text"> Employee ID</div>
										</Grid>
										<Grid item xs={9} sm={9} md={9} lg={9} xl={9}>
											<div className="auto-complete">
												<Autocomplete
													onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
														handleSearchEmployeeChange(event, "member_id")
													}
													//inputValue={"hi"}
													getItemValue={(item: Member) => item.first_name}
													onSelect={handleSelectSearchedEmployee}
													items={employees}
													value={searchMemberIdQuery}
													menuStyle={{
														maxHeight: "200px",
														overflowX: "hidden",
														scrollBehavior: "smooth",
														zIndex: 1,
														border: "1px solid #ccc",
														borderRadius: "4px",
														boxShadow: "0 2px 12px rgba(0, 0, 0, 0.1)"
													}}
													renderItem={(
														employee: Member & { open_enrollment: any },
														isHighlighted: boolean
													) => {
														return (
															<div
																className={
																	employee.open_enrollment
																		? "opened-option"
																		: isHighlighted
																		? "highlighted-option option"
																		: "option"
																}
															>{`${employee.first_name} ${employee.last_name} ${
																employee.open_enrollment ? "(Opened)" : ""
															}`}</div>
														);
													}}
												/>
											</div>
										</Grid>
									</Grid>
								</Grid>
								<Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
									<Grid container spacing={1} className="pf-label">
										<Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
											<div className="pf-label-text">Search by Employee First Name</div>
										</Grid>
										<Grid item xs={9} sm={9} md={9} lg={9} xl={9}>
											<div className="auto-complete">
												<Autocomplete
													onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
														handleSearchEmployeeChange(event, "first_name")
													}
													onSelect={handleSelectSearchedEmployee}
													getItemValue={(item: Member) => item.first_name}
													items={employees}
													value={searchFirstNameQuery}
													menuStyle={{
														maxHeight: "200px",
														overflowX: "hidden",
														scrollBehavior: "smooth",
														zIndex: 1,
														border: "1px solid #ccc",
														borderRadius: "4px",
														boxShadow: "0 2px 12px rgba(0, 0, 0, 0.1)"
													}}
													renderItem={(
														employee: Member & { open_enrollment: any },
														isHighlighted: boolean
													) => {
														return (
															<div
																className={
																	employee.open_enrollment
																		? "opened-option"
																		: isHighlighted
																		? "highlighted-option option"
																		: "option"
																}
															>
																<span>
																	{`${employee.first_name} ${employee.last_name} ${
																		employee.open_enrollment ? "(Opened)" : ""
																	}`}
																</span>
															</div>
														);
													}}
												/>
											</div>
										</Grid>
									</Grid>
								</Grid>
								<Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
									<Grid container spacing={1} className="pf-label">
										<Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
											<div className="pf-label-text">Search by Employee Last Name</div>
										</Grid>
										<Grid item xs={9} sm={9} md={9} lg={9} xl={9}>
											<div className="auto-complete">
												<Autocomplete
													onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
														handleSearchEmployeeChange(event, "last_name")
													}
													onSelect={handleSelectSearchedEmployee}
													//inputValue={"hi"}
													getItemValue={(item: Member) => item.last_name}
													//clearOnBlur
													menuStyle={{
														maxHeight: "200px",
														overflowX: "hidden",
														scrollBehavior: "smooth",
														zIndex: 1,
														border: "1px solid #ccc",
														borderRadius: "4px",
														boxShadow: "0 2px 12px rgba(0, 0, 0, 0.1)"
													}}
													items={employees}
													value={searchLastNameQuery}
													renderItem={(
														employee: Member & { open_enrollment: any },
														isHighlighted: boolean
													) => {
														return (
															<div
																className={
																	employee.open_enrollment
																		? "opened-option"
																		: isHighlighted
																		? "highlighted-option option"
																		: "option"
																}
															>{`${employee.first_name} ${employee.last_name} ${
																employee.open_enrollment ? "(Opened)" : ""
															}`}</div>
														);
													}}
												/>
											</div>
										</Grid>
									</Grid>
								</Grid>
								<Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
									<Grid container spacing={1} className="pf-label">
										<Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
											{/* <div className="pf-label-text">Search by Employee ALT-ID</div> */}
											<div className="pf-label-text">
												Search by Employee{" "}
												{currentGroup?.SSN_provided_by_group ? "SSN" : "ALT-ID"}
											</div>
										</Grid>
										<Grid item xs={9} sm={9} md={9} lg={9} xl={9}>
											<div className="auto-complete">
												<Autocomplete
													onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
														handleSearchEmployeeChange(event, "SSN")
													}
													onSelect={handleSelectSearchedEmployee}
													//inputValue={"hi"}
													getItemValue={(item: Member) => item.SSN}
													//clearOnBlur
													menuStyle={{
														maxHeight: "200px",
														overflowX: "hidden",
														scrollBehavior: "smooth",
														zIndex: 1,
														border: "1px solid #ccc",
														borderRadius: "4px",
														boxShadow: "0 2px 12px rgba(0, 0, 0, 0.1)"
													}}
													items={employees}
													value={searchSSNQuery}
													renderItem={(
														employee: Member & { open_enrollment: any },
														isHighlighted: boolean
													) => {
														return (
															<div
																className={
																	employee.open_enrollment
																		? "opened-option"
																		: isHighlighted
																		? "highlighted-option option"
																		: "option"
																}
															>{`${employee.first_name} ${employee.last_name} ${
																employee.open_enrollment ? "(Opened)" : ""
															}`}</div>
														);
													}}
												/>
											</div>
										</Grid>
									</Grid>
								</Grid>
								{selectedEmployees.length > 0 ? (
									<SelectedEmployeeGrid
										selectedEmployees={selectedEmployees}
										setSelectedEmployees={setSelectedEmployees}
										type="SPECIFIC"
									/>
								) : null}
							</Paper>
						</Grid>
					</div>
				) : null}
				{coreOpenEnrollmentPermission && coreOpenEnrollmentPermission.update && (
					<div className="pf-action-button-container enroll-action-btn">
						<Button
							className="button-green"
							variant="contained"
							onClick={
								openEnrollment?.type === "BULK" && hasVerifiedBulkOpenEnrollmentFile === false
									? handleVerifyBulkOpenEnrollmentFileClick
									: handleOpenEnrollmentSubmitClick
							}
						>
							<span className="button-label-with-icon">
								{openEnrollment?.type === "BULK" && hasVerifiedBulkOpenEnrollmentFile === false
									? "Verify"
									: "Submit"}
							</span>
							<span>
								<SendIcon className="button-icon" />
							</span>
						</Button>
					</div>
				)}
			</div>
		</>
	);
};

export default OpenEnrollment;
